import React from 'react';

const InfoTooltip = () => {
  return (
    <>
      Days on Market by Size displays the{' '}
      <span className="bold">
        time between a lot becoming available and being sold
      </span>
      , grouped by lot size bands.
      <br />
      <br />
      Use the <span className="bold">Median / Average</span> toggle to switch
      between the median and average calculation for each size band.
      <br />
      <br />
      The <span className="bold">ALL LOTS</span> value shows a weighted
      calculation across all size bands based on the number of lots sold.
      <br />
      <br />
      <span className="italic">
        Use the slider to adjust the date range of sold lots included in the
        calculation.
      </span>
    </>
  );
};

export default InfoTooltip;
